import { Link } from 'react-router-dom'

const FooterLinks = () => {
	return (
		<div className='footer-section footer-links'>
			<div className='link-wrapper'>
				<p className='footer-heading'>Quick Links</p>
				<Link
					className='link'
					to='/about-us'>
					About Us
				</Link>
				<Link
					className='link'
					to='/FAQs'>
					FAQ
				</Link>
				<Link
					className='link'
					to='/blogs'>
					Blogs
				</Link>
				<Link
					className='link'
					to='/careers'>
					Careers
				</Link>
				<Link
					className='link'
					to='/contact-us?advertiseWithUs=true'>
					Advertise on Kewordal
				</Link>
				<Link
					className='link'
					to='/contact-us?safeguarding=1'>
					Safeguarding Contact
				</Link>
			</div>
		</div>
	)
}

export default FooterLinks
